import { isCopyableDragClick } from './copyableSelection';

/** Brief window after an ActionMenu item fires — blocks ghost taps on list rows. */
export const ACTION_MENU_ROW_CLICK_GUARD_MS = 450;

let suppressUntil = 0;

/** Call when an ActionMenu item activates (before the row underneath can receive a ghost click). */
export function markActionMenuItemActivated() {
  suppressUntil = Date.now() + ACTION_MENU_ROW_CLICK_GUARD_MS;
}

/** True while a recent menu item click should not also open the parent row. */
export function shouldSuppressRowActivateAfterActionMenu() {
  return Date.now() < suppressUntil;
}

/** Wrap a row activate handler so ActionMenu ghost clicks are ignored. */
export function guardRowActivate(onActivate) {
  if (typeof onActivate !== 'function') return onActivate;
  return (...args) => {
    if (shouldSuppressRowActivateAfterActionMenu()) return;
    // KAN-962: the click that ends a mouse drag-select on a CopyableValue is not a tap on the row.
    if (isCopyableDragClick(args[0])) return;
    onActivate(...args);
  };
}
